import { FormattedMessage } from 'react-intl';
import { type JSX } from 'react/jsx-runtime';

export const whyAmISeeingThisRecommendationMessageDefaultReason: JSX.Element[] = [
	<FormattedMessage
		id="post-office.ad-controls.default-reason.team-size"
		description="the first reason for displaying the message to the customer: the size of the customer's team"
		defaultMessage="the size of your team"
	/>,
	<FormattedMessage
		id="post-office.ad-controls.default-reason.existing-products"
		description="the second reason for displaying the message to the customer: the customer's existing Atlassian products"
		defaultMessage="your existing Atlassian products"
	/>,
];
